// ** Initial State
const initialState = {
    result_list: [],
    result: null,
    total: 0,
    notificationSign: null,
    notificationTimestamp: null,
    notificationEndpoint: null,
    notificationRoomID: null,
    page: 1
}

const chatIncludedList = (state = initialState, action) => {
    switch (action.type) {
        case 'CHAT_INCLUDED_LIST':
            return {
                ...state,
                result_list: action.data,
                total: action.total,
                page: action.page || 1
            }
        default:
            return { ...state }
    }
}

const chatIncludedById = (state = initialState, action) => {
    switch (action.type) {
        case 'CHAT_INCLUDED_VIEW':
            return {
                ...state,
                result: action.data
            }
        default:
            return { ...state }
    }
}

const clearResultChatIncluded = (state = initialState, action) => {
    switch (action.type) {
        case 'CHAT_INCLUDED_CLEAR':
            return {
                ...state,
                result: null,
                result_list: [],
                total: 0
            }
        default:
            return { ...state }
    }
}

const chatNotificationSign = (state = initialState, action) => {
    switch (action.type) {
        case 'CHAT_NOTIFICATION_SIGN':
            return {
                ...state,
                notificationTimestamp: action.data?.ws?.timestamp || null,
                notificationEndpoint: action.data?.ws?.url || null
            }
        default:
            return { ...state }
    }
}

export {
    chatIncludedList,
    chatIncludedById,
    clearResultChatIncluded,
    chatNotificationSign
}
